import React, { useState } from 'react'

import { SchemaWatemplate } from '@/__generated/es-api'
import TableRowActions from '@/app/component/layout/table/actions'
import { useGetWaTemplateRefresh } from '@/app/module/content/hooks/use-get-wa-template-refresh'

import ReRegisterDialog from './re-register-dialog'

type RowActionsProps = {
  template: SchemaWatemplate
}

const RowActions: React.FC<RowActionsProps> = ({ template }) => {
  const [refreshTemplate, { isLoading }] = useGetWaTemplateRefresh()
  const [isReRegisterOpen, setReRegisterOpen] = useState(false)

  const handleRefresh = React.useCallback(() => {
    refreshTemplate(template.id)
  }, [template.id, refreshTemplate])

  return (
    <>
      <TableRowActions
        config={[
          {
            icon: 'refresh',
            label: 'Check for updates',
            tooltip: 'Check WhatsApp for the latest template status',
            disabled: isLoading,
            onClick: handleRefresh,
          },
          {
            icon: 'app_registration',
            label: 'Re-register',
            tooltip: 'Re-register template with new examples',
            onClick: () => setReRegisterOpen(true),
          },
        ]}
      />
      <ReRegisterDialog open={isReRegisterOpen} onClose={() => setReRegisterOpen(false)} template={template} />
    </>
  )
}

export default RowActions
